import {useCardsTemplate} from 'Event/template/Cards'
import {rgba} from 'lib/color'
import React from 'react'
import styled from 'styled-components'

export default function Heading(props: {
  children: string
  'aria-label'?: string
  className?: string
}) {
  const {sidebar} = useCardsTemplate()
  const backgroundRGBColor = rgba(
    sidebar.headBackgroundColor,
    sidebar.headerOpacity / 100,
  )
  return (
    <StyledContainer
      color={backgroundRGBColor}
      border={sidebar.headBackgroundBorder}
      className={props.className}
    >
      <Text aria-label={props['aria-label']} color={sidebar.headTextColor}>
        {props.children}
      </Text>
    </StyledContainer>
  )
}

const StyledContainer = styled.div<{
  color?: string
  border?: number
}>`
  background-color: ${(props) => props.color};
  border-radius: ${(props) => props.border}px ${(props) => props.border}px 0px
    0px;
  margin-left: -${(props) => props.theme.spacing[8]};
  margin-right: -${(props) => props.theme.spacing[8]};
`

const Text = styled.h2<{
  color: string
}>`
  margin: 0 0 ${(props) => props.theme.spacing[2]};
  padding: ${(props) => props.theme.spacing[1]};
  font-size: 30px;
  font-weight: bold;
  color: ${(props) => props.color};
  text-align: center;
  &:empty {
    width: ${(props) => props.theme.spacing[14]};
    height: ${(props) => props.theme.spacing[8]};
  }
`
